<template>
  <div class="footer flex flex-col">
    <div class="main flex-1 flex text-14px">
      <img src="@/assets/images/logo.png" class="logo cursor-pointer" @click="jumphome"/>
      <div class="flex-1 navs">
        <p class="font-bold"></p>
        <p class="mt-15px text-0.1rem">
          <a class="mr-20px cursor-pointer" v-for="item in navbarLists" :key="item.path" @click="goModule(item)" style="font-size: 0.1rem;">{{
            $t(item.name) }}</a>
          <a class="mr-20px cursor-pointer" style="font-size: 0.1rem; position: relative;"  @mouseenter="yzpay=true" @mouseleave="yzpay=false" >
          <img src="@/assets/images/wxpay.jpg" style="width: 250px; position: absolute; top: -348px; left: -100px; z-index: 1000;" v-show="yzpay">
            {{ $t('header.donation') }}
          </a>
        </p>
      </div>
      <div class="py-15px address">
        <div class="mr-40px">
          <p class="font-bold">地址</p>
          <p class="mt-15px">{{ contactInfo.address }}</p>
        </div>
        <img src="@/assets/images/qr_code.jpg" class="ma" />
      </div>
    </div>
    <div class="copyright flex flex-col text-grey text-12px text-center p-9px">
      <span>版权所有：始智AI
        <a href="https://beian.miit.gov.cn" target="_blank" class="ml-10px">京ICP备2023010025号-1</a>
        <a href="https://beian.mps.gov.cn" target="_blank" class="ml-10px">京公网安备11010802041791号</a>
      </span>
    </div>
  </div>
</template>

<script>
import navbars from '@/config/narbars'
export default {

  components: {},
  data() {
    return {
      yzpay:false,
      navbarLists: navbars,
      contactInfo: {
        email: 'daoquan.liu@tsingdata.com',
        address: '北京市海淀区同方科技大厦D座西楼18层'
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    showImage(){
console.log('ttttt');
    },
    goModule(item) {
      if (item.path === '/waiting') {
        this.$message.warning('敬请期待')
        return
      }
      this.$router.push({
        path: item.path
      })
    },
    jumphome(){
      this.$router.push('/home')
    }
  }
}
</script>
<style lang="scss" scoped>

.footer {
  background: #fff;
  border-top: 1px solid #e1dce9;

  .main {
    padding: 0 181px;
    align-items: center;

    .navs {
      margin-left: 100px;
    }

    .address {
      display: flex;
      align-items: center;
    }

    .logo {
      width: 140px;
    }

    .ma {
      width: 70px;
      height: 71px;
    }
  }

  .copyright {
    border-top: 1px solid #e1dce9;
  }

  a {
    &:hover {
      text-decoration: underline;
    }
  }
}

@media only screen and (max-width: 768px) {
  .footer {
    .main {
      padding: 20px 80px;
      flex-direction: column;
      align-items: flex-start;

      .navs {
        margin-left: 0;
        margin-top: 15px;
      }

      .address {
        margin-top: 15px;
        width: 100%;
        position: relative;
      }

      .logo {
        width: 350px;
        margin: 0 auto;
      }

      .ma {
        width: 250px;
        height: 251px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }

    .copyright {
      display: none;
    }
  }
}

</style>
